import axios from 'axios';

import { GOOGLE_MAPS_API_KEY } from '../env';

export default class GeolocationService {
    static findLatLonFromIP(){
        return axios.post(`https://www.googleapis.com/geolocation/v1/geolocate?key=${GOOGLE_MAPS_API_KEY}`, {
            considerIp: true
        });
    }
}